const brandImageModules = import.meta.glob("./*.png", {
	eager: true,
	import: "default",
})

export const brandImages = Object.values(brandImageModules) as string[]

export const getRandomBrandImage = () => {
	if (brandImages.length === 0) {
		return ""
	}

	return brandImages[Math.floor(Math.random() * brandImages.length)]
}
